/** localStorage 键：用户语言偏好 */
export const LOCALE_STORAGE_KEY = 'app_locale'

/** 支持的语言 */
export const SUPPORTED_LOCALES = [
  { value: 'zh-CN', label: '中文' },
  { value: 'en', label: 'EN' }
]

export const DEFAULT_LOCALE = 'zh-CN'
export const FALLBACK_LOCALE = 'zh-CN'

/** 读取已保存语言，非法值回退默认 */
export function readStoredLocale () {
  const raw = localStorage.getItem(LOCALE_STORAGE_KEY)
  if (raw && SUPPORTED_LOCALES.some((item) => item.value === raw)) {
    return raw
  }
  return DEFAULT_LOCALE
}
